import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { Suspense } from 'react';

import { CustomerShell } from './components/layout/CustomerShell';
import { LoadingScreen } from './components/common/LoadingScreen';
import { useAuth } from './hooks/useAuth';
import { LoginPage } from './pages/LoginPage';
import { OverviewPage } from './pages/OverviewPage';
import { LicensesPage } from './pages/LicensesPage';
import { DevicesPage } from './pages/DevicesPage';
import { AccountPage } from './pages/AccountPage';

function ProtectedLayout() {
  const { account, loading } = useAuth();

  if (loading) {
    return <LoadingScreen message="Checking session..." />;
  }

  if (!account) {
    return <Navigate to="/login" replace />;
  }

  return (
    <CustomerShell>
      <Outlet />
    </CustomerShell>
  );
}

function ShellWrapper() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <ProtectedLayout />
    </Suspense>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ShellWrapper />,
    children: [
      { path: '/', element: <OverviewPage /> },
      { path: '/licenses', element: <LicensesPage /> },
      { path: '/devices', element: <DevicesPage /> },
      { path: '/account', element: <AccountPage /> }
    ]
  },
  { path: '*', element: <Navigate to="/" replace /> }
]);

